export default __webpack_public_path__ + "static/media/dipu.c3545ce1.JPG";